<div
  #wrapper
  [class.is-dragover-dialog]="isDragoverDialog()"
  (dragenter)="isDragoverDialog.set(true)"
  (dragleave)="onDragleaveDialog($event)"
  (dragover)="$event.preventDefault()"
>
  <rt-dialog-header
    [heading]="
      (mode === 'create' ? 'wysiwyg.image_plugin.add_image' : 'wysiwyg.image_plugin.edit_image')
        | translate
    "
  />
  <rt-dialog-body layout-horizontal>
    <div class="col">
      <div
        #dropArea
        class="drop-area"
        [class.is-empty]="!form.get('src')?.value"
        [class.is-dragover-area]="isDragoverArea()"
        (dragenter)="isDragoverArea.set(true)"
        (dragleave)="onDragleaveArea($event)"
        (drop)="onDrop($event)"
      >
        @if (form.get('src')?.value) {
          <img
            [src]="$safeNavigationMigration(form.get('src')?.value)"
            [alt]="$safeNavigationMigration(form.get('alt')?.value)"
          />
        }
        <div class="empty-state">
          <rt-icon name="image" colorToken="colorIconDefault" size="large-x" />
          <span class="text">{{ 'wysiwyg.image_plugin.empty_desc' | translate }}</span>
        </div>
        <div class="drop-indicator">
          <rt-icon name="cloud-upload" colorToken="colorIconPrimaryDefault" size="large-x" />
          <span class="text">{{ 'wysiwyg.image_plugin.drop_here' | translate }}</span>
        </div>
      </div>
      <rt-button (click)="fileInput.click()" variant="outline">{{
        'wysiwyg.image_plugin.upload' | translate
      }}</rt-button>
    </div>
    <div class="col">
      <form [formGroup]="form" class="form-wrap">
        <rt-form-field>
          <rt-label
            >{{ 'wysiwyg.image_plugin.alt_label' | translate
            }}<rt-icon-help
              margin-left-small-xx
              [rtTooltip]="'wysiwyg.image_plugin.alt_tooltip' | translate"
              [rtTooltipPosition]="'right'"
          /></rt-label>
          <rt-input formControlName="alt" />
        </rt-form-field>
        <rt-form-field>
          <rt-label>{{ 'wysiwyg.image_plugin.caption_label' | translate }}</rt-label>
          <rt-input formControlName="caption" />
        </rt-form-field>
        <rt-form-field>
          <rt-label>{{ 'wysiwyg.image_plugin.link_label' | translate }}</rt-label>
          <rt-input formControlName="href" />
        </rt-form-field>
        <rt-form-field>
          <rt-checkbox formControlName="targetBlank">{{
            'wysiwyg.image_plugin.new_tab_label' | translate
          }}</rt-checkbox>
        </rt-form-field>
      </form>
    </div>
  </rt-dialog-body>
  <rt-dialog-footer [hasOptionalActions]="true">
    @if (mode === 'edit') {
      <rt-button
        class="optional danger-on-hover"
        (click)="callbacks.delete && callbacks.delete()"
        variant="plain"
        ><rt-icon prefix name="delete" />{{ 'wysiwyg.delete' | translate }}</rt-button
      >
    }
    <rt-button (click)="callbacks.cancel()" variant="plain">{{
      'wysiwyg.cancel' | translate
    }}</rt-button>
    <rt-button [disabled]="!form.valid" (click)="apply()" variant="primary">{{
      'wysiwyg.save' | translate
    }}</rt-button>
  </rt-dialog-footer>
  <input
    (change)="fileInputChanged(fileInput.files, fileInput)"
    #fileInput
    type="file"
    accept="image/*"
    hidden
  />
</div>
